export default {
    title: 'اهلا بك',
    yourProfile: 'بيانتي',
    profileVisitors: 'زوار بياناتي',
    sentMessages: 'الرسايل المرسلة',
    receivedMessages: 'الرسايل الواردة',
    membershipTitle: 'هل تريد ان تزيد من المعجبين ?',
    membershipText: 'يمكنك الضغط على اعلاء العضوية...لا تتردد اضغط هنا حتى تصبح من المعرفين اكثر',
    likesReceivedTitle: 'عدد المعجبين',
    likesReceivedText: 'المعجبين',
    numberOfLikes: 'عدد المعجبين: ',
    likesMadeTitle: 'عدد الاعجابات',
    likesMadeText: 'انت معجب %{count} ب',
    editProfile: 'تعديل الملف',
    uploadImages: 'تحميل الصور',
    blocksMade: 'عدد المحظورين في حسابك',
    blocksReceived: 'عدد اللذين حظروك',
    blockedUsers: 'مشاركين ممنوعين',
    blockedUsersText: 'عدد اللذين حظرتهم',
    profilePictures: 'صور بياناتي',
    changeProfilePictures: 'تغيرر صور ملفي يمكن تغيير 4 صور.',
    removePicture: 'الغاء الصور',
    changePicture: 'تغيير الصور'
}
